import { render, staticRenderFns } from "./SalesOrderDetailUnDeliveryList.vue?vue&type=template&id=33cafc75&"
import script from "./SalesOrderDetailUnDeliveryList.vue?vue&type=script&lang=js&"
export * from "./SalesOrderDetailUnDeliveryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports